<template>
  <div class="login-body">
    <div class="login-loading-box">
      <div class="text">登录中</div>
      <Loading v-if="isLoading"></Loading>
    </div>
    <div class="login-card-container" v-if="showLoginCard">
      <LoginCard @loginSuccess="onLoginSuccess"></LoginCard>
    </div>
  </div>
</template>
<script>
  import LoginCard from "../common/LoginCard";
  import TopNavbar from "../common/TopNavbar";
  import {Toast, Loading} from "vant"

  export default {
    name: "LoginSso",
    components: {Loading, TopNavbar, LoginCard, Toast},
    data() {
      return {
        ak: "",
        toPath: "/",
        isLoading: true,
        showLoginCard: false,
      }
    },
    mounted() {
      this.ak = this.$route.query.ak || ""
      let to = this.$route.query.to
      if (to) {
        this.toPath = to
      }
      this.loginAk()
    },
    methods: {
      onLoginSuccess() {
        this.$router.push({
          path: this.toPath,
          query: this.$route.query || {}
        })
      },

      async loginAk() {
        if (this.ak) {
          let params = {
            "ak": this.ak,
          }
          this.isLoading = true
          await this.$store.dispatch("AuthLoginAk", params).then((data) => {
            if (data.code === 0) {
              this.onLoginSuccess()
            } else {
              this.showLoginCard = true
            }
          }, () => {
            Toast("网络错误")
            this.showLoginCard = true
          })
          this.isLoading = false
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-body {
    .login-loading-box {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 25px 0;
      .text {
        color: #333;
        line-height: 3;
        font-size: 22px;
        font-weight: bold;
      }
    }
  }

  .login-card-container {
    margin: 15px;
  }

</style>
